export default __webpack_public_path__ + "static/media/giraffe-green.c9f557a5.svg";